<template>
    <svg viewBox="0 0 32 32" :width="width" :height="height" xmlns="http://www.w3.org/2000/svg">
        <path :fill="color"
              d="M28,8H21V6a2,2,0,0,0-2-2H13a2,2,0,0,0-2,2V8H4a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM13,6h6V8H13Zm15,4v9H4V10ZM4,26V21H28v5Z"/>
        <path :fill="color" d="M15,18h2a1,1,0,0,0,0-2H15a1,1,0,0,0,0,2Z"/>
    </svg>
</template>

<script>
    export default {
        props: ['height', 'width', 'color']
    }
</script>
